module.exports = __webpack_public_path__ + "static/img/bgcbgc.379ffd04.png";